var $0e9f1c25f5631e6c$exports = {};
$0e9f1c25f5631e6c$exports = {
    "collectionLabel": `\u{3A0}\u{3C1}\u{3BF}\u{3C4}\u{3AC}\u{3C3}\u{3B5}\u{3B9}\u{3C2}`
};


export {$0e9f1c25f5631e6c$exports as default};
//# sourceMappingURL=el-GR.module.js.map
